import { PropsWithChildren, ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { IconType } from "react-icons";
import { ErrorBoundaryFallback } from "@app/shared/src/components/ErrorBoundaryFallback";

type PageContainerProps = {
    title: string | ReactNode;
    Icon?: IconType;
    titleRight?: string | ReactNode;
    className?: string;
};

export const PageContainer: React.FC<PropsWithChildren<PageContainerProps>> = ({ children, Icon, ...props }) => {

    return (
        <div className={`w-full my-4 p-0 shadow-sm border border-l border-r border-b border-separators-page flex flex-col flex-1 min-h-0 ${props.className}`}>
            {/* flex-wrap: a title-right slot holding filters or an action drops under the title on
                a phone instead of squeezing the title into a three-line column beside it. */}
            <div className="flex flex-wrap items-center gap-y-2 px-3 py-2 m-0 bg-background-container-title" style={{ minHeight: 60 }}>
                <div className="flex-grow text-semi-bright-text uppercase flex items-center font-semibold gap-x-3 min-w-0">
                    {Icon &&
                        <Icon className="w-7 h-7" />
                    }
                    <div>
                        {props.title}
                    </div>
                </div>
                {props.titleRight &&
                    <div className="max-w-full">
                        {props.titleRight}
                    </div>
                }
            </div>
            <div className="p-3 flex-1 min-h-0">
                <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
                    {children}
                </ErrorBoundary>
            </div>
        </div>
    );
}